import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, TYPEMESSAGE, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { RolService } from '../../Roles/shared/rol.service';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';

@Component({
  selector: 'app-rol-list',
  // styleUrls: ['table-basic-example.css'],
  templateUrl: 'rol-list.component.html',
})

export class RolListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  // dataSource = ELEMENT_DATA;

  pageSize: number;
  pageEvent: PageEvent;
  displayedColumns: string[] = ['indCheck', 'RolID', 'Name', 'Descripcion', 'Status'];
  dataSource: GridDataSource; //MatTableDataSource<Irol>;
  msgErrorGet: string;
  selectedRowIndex: number = -1;
  buttonGroup: any;
  showMessageGridEmpty: boolean = false;
  pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

  constructor(private loaderService: LoaderService, private rolService: RolService,
    private errorService: ErrorService, private notificationService: NotificationService,
    private utilityService: UtilityService, private aplicacionService: AplicacionService
  ) { }

  ngOnInit() {
    this.pageSize = CONSTANT.pageSize;
    this.pageEvent = new PageEvent();
    this.clearMatPaginator();
    this.msgErrorGet = 'Error al listar rol';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
    ];
    // this.buscarRol("");
  }

  handleRowClick(row: any) {
    this.selectedRowIndex = row.ID;
    this.data.rol = { ID: row.ID, Name: row.Name };
    this.changeEvent({ evento: EVENTO.consultar, data: this.data });
  }

  private clearMatPaginator() {
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.pageEvent.length = 0;
  }

  private setMatPaginator() {
    this.paginator.length = this.pageEvent.length;
    this.paginator.pageIndex = this.pageEvent.pageIndex;
    this.paginator.pageSize = this.pageEvent.pageSize;
  }

  searchEmit(data: any) {
    this.buscarRol(this.sectionBarComponent.officeID, this.data.aplicacion.ID, data.filtro);
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  onNew() {
    this.changeEvent({ evento: EVENTO.crear, data: {} });
  }

  pageEventPaginator(value) {
    this.pageEvent = value;
    // this.listarRolAccess('');
  }

  buscarRol(officeID: number, AplicacionId: number, filtro: string) {
    this.clearMatPaginator();
    this.listarRolAccess(officeID, AplicacionId, filtro);
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.new:
        this.onNew();
        break;
      default:
        break;
    }
  }

  private listarRolAccess(officeID: number, aplicacionID: number, filtro: string,): void {
    this.loaderService.show();
    this.rolService.listarRolAccess(officeID, aplicacionID, filtro, this.pageEvent.pageIndex, this.pageEvent.pageSize)
      .subscribe(res => {
        // if (this.errorService.getMessageError(res)) {
        this.dataSource = new GridDataSource(res); //new GridDataSource(res);
        this.showHideMessageGridEmpty(Number(res.length));
        this.pageEvent.length = res.length;
        this.setMatPaginator();
        // }
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  onChangeVinculacion(event: any, row: any) {
    let AplicacionID: number;
    if (event.checked)
      AplicacionID = this.data.aplicacion.ID;
    else
      AplicacionID = this.data.aplicacion.ID;

    this.toggleOfficeRol(row.ID, AplicacionID, this.sectionBarComponent.officeID, event.checked)
  }

  private toggleOfficeRol(RoleID: number, AplicacionID: number, OfficeID: number, pToggle: boolean): void {
    this.loaderService.show();
    this.aplicacionService.toggleAplicacionRol(RoleID, AplicacionID, OfficeID, pToggle)
      .subscribe(res => {
        this.notificationService.successful("Se grabo satisfactoriamente");
      },
        error => {
          // this.notificationService.showMessage(this.msgErrorToggleVincularCorreoAfiliado, TYPEMESSAGE.Error);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }

  public showHideMessageGridEmpty(rows: number) {
    this.showMessageGridEmpty = false;
    if (rows <= 0) this.showMessageGridEmpty = true;
  }
}

